export const FIRST_PAGE_COMPONENT = '.aem-Grid > :first-child:not(owc-header)';
